export const SALES_LOADING = "SALES_LOADING";
export const SALES_RESET = "SALES_RESET";
export const GET_SALES = "GET_SALES";
export const GET_SALES_ONE = "GET_SALES_ONE";
export const GET_SALES_SUCCESS = "GET_SALES_SUCCESS";
export const GET_SALES_FAIL = "GET_SALES_FAIL";
export const DELETE_SALES = "DELETE_SALES"
export const DELETE_SALES_SUCCESS = "DELETE_SALES_SUCCESS"
export const DELETE_SALES_FAIL = "DELETE_SALES_FAIL"
export const UPDATE_SALES = "UPDATE_SALES"
export const UPDATE_SALES_SUCCESS = "UPDATE_SALES_SUCCESS"
export const UPDATE_SALES_FAIL = "UPDATE_SALES_FAIL"
export const ADD_NEW_SALES = "ADD_NEW_SALES"
export const ADD_SALES_SUCCESS = "ADD_SALES_SUCCESS"
export const ADD_SALES_FAIL = "ADD_SALES_FAIL"